import React from 'react';
import {motion} from 'framer-motion';

import * as styles from './styles.module.scss';

interface DotsProps {
  numberOfDots?: number;
  speed?: number;
}

export const Dots: React.FC<DotsProps> = ({
	numberOfDots = 7,
	speed = 1.5,
}) => {
	// Calculate delay for each dot
	const getDelay = (index: number): number => index * speed * 0.1;

	// Animation settings
	const dotVariants = {
		initial: {
			opacity: 0.3,
			scale: 0.8
		},
		animate: {
			opacity: 1,
			scale: 1
		}
	};

	// Create array from number of dots
	const dots = Array.from({length: numberOfDots}, (_, i) => i);

	return (
		<div className={styles.dots}>
			{dots.map((_, index) => (
				<motion.div
					key={index}
					className={styles.dot}
					initial={speed ? 'initial' : false}
					animate={speed ? 'animate' : false}
					variants={dotVariants}
					transition={{
						duration: speed,
						repeat: Infinity,
						repeatType: 'reverse',
						delay: getDelay(index)
					}}
				/>
			))}
		</div>
	);
};
